import Vue from 'vue'
import Vuex from 'vuex'
import gallery from "./modules/gallery"
import auth from "./auth"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'',
    description:'',
    file:'',
    categories:JSON.parse(localStorage.getItem('categories')) || [],
    langs:JSON.parse(localStorage.getItem('langs')) || [],
    tags:JSON.parse(localStorage.getItem('tags')) || [],
    top_members:JSON.parse(localStorage.getItem('top_members')) || [],
    options:JSON.parse(localStorage.getItem('options')) || [],
  },
  mutations: {
    updatePicState(state,data){
      state.categories=data.categories;
      state.langs=data.langs;
      state.tags=data.tags;
      state.top_members=data.top_members;
      state.options=data.options;

      localStorage.setItem('categories',JSON.stringify(state.categories))
      localStorage.setItem('options',JSON.stringify(state.options))
      localStorage.setItem('langs',JSON.stringify(state.langs))
      localStorage.setItem('tags',JSON.stringify(state.tags))
      localStorage.setItem('top_members',JSON.stringify(state.top_members))
      
   },
  },
  actions: {
    fetchPicData({commit}){
      fetch(`https://pic.imamhussain.org/index.php/Home`).then(res=>res.json()).then(res=>{
          commit('updatePicState',res)
      });
  },
  },
  modules: {
    gallery,auth
  }
})
